import { useEffect, useState } from "react"
import { Vehicle } from "../../../state/types"
import { useVehicleLoaders } from "../../../loaders/vehicleLoaders"
import { PanelLoader } from "../../../../../features/ui"
import { BookmarkButton } from "../../../../../features/bookmarks"
import { RoutePath } from "../../../../../features/routes"
import { ListLoaderWrapper } from "../../../../../features/data-types"
import { TableName } from "../../../../../tables"
import { VehicleList } from "./vehicleList"

export const Loader = () => {
    const [vehicles, setVehicles] = useState<Vehicle[]>([])
    const [ready, setReady] = useState(false)

    const vehicleLoaders = useVehicleLoaders()

    const populate = async () => {
        const { loadAllVehicles } = vehicleLoaders()
        const loadedVehicles = await loadAllVehicles(true)
        setVehicles(loadedVehicles)
    }

    useEffect(() => {
        populate().then(() => setReady(true))
    }, [])

    return (
        <PanelLoader
            title="Vehículos"
            ready={ready}
            titleRight={<BookmarkButton routePath={RoutePath.VEHICLES} />}
        >
            <VehicleList vehicles={vehicles} />
        </PanelLoader>
    )

}

export const VehicleListLoader = () => (
    <ListLoaderWrapper table={TableName.VEHICLES}>
        <Loader />
    </ListLoaderWrapper>
)
